export const GET_PROVINCES = 'GET_PROVINCES';
export const GET_PROVINCES_SUCCESS = 'GET_PROVINCES_SUCCESS';
export const GET_PROVINCES_FAILED = 'GET_PROVINCES_FAILED';
